var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.951 277.962l67.433-49.478h-83.509L256 148.846l-25.875 79.638h-83.509l67.433 49.478-25.675 79.022 67.56-48.289.066.047.066-.047 67.56 48.289-25.675-79.022zm13.527-31.823l-19.273 14.141-4.595-14.141h23.868zm-76.694 25.139l8.169-25.14h26.094l8.169 25.14L256 286.846l-21.216-15.568zM256 205.984l7.31 22.5h-14.622l7.312-22.5zm-55.478 40.155h23.868l-4.595 14.141-19.273-14.141zm21.215 65.293l7.302-22.472 11.911 8.739-19.213 13.733zm61.225-22.472l7.302 22.472-19.212-13.732 11.91-8.74z",
    fill: "#5a8250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/ma.a954ed1a7dbd996081b451be5b128615.svg";
export { ForwardRef as ReactComponent };